import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { getOrderId, getOrderingSystem, getSelectedOrder, getSelectedShop } from '../../../../../selectors/tools';
import { trackDecisionTreeOrderShippingRefunded } from '../../../../../analytics/searchEventAnalytics';
import { shopifyRefundOrderShippingAmount } from '../../../../../actions/tools/ShopifyActions';
import { extractNonHistoricalTicketIdFromState, getActionReasons } from '../../../../../extractFromState';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';

const DTRefundShippingThenSendMacroNode = () => {
  const dispatch = useDispatch();
  const selectedOrder = useSelector(getSelectedOrder);
  const orderingSystem = useSelector(getOrderingSystem);
  const selectedConversationId = useSelector(extractNonHistoricalTicketIdFromState);
  const selectedShop = useSelector(getSelectedShop);
  const orderId = getOrderId(selectedOrder, orderingSystem);
  const actionReasons = useSelector(getActionReasons);

  const handleNextButtonClick = async () => {
    const payload = {
      orderId: orderId && orderId.toString(),
      comment:
        actionReasons?.refundPrimaryReason ||
        actionReasons?.cancelOrRefundPrimaryReason ||
        'Order shipping amount is refunded upon customer request',
      shopName: selectedShop,
      addNotes: true,
      conversationId: selectedConversationId,
    };

    await dispatch(shopifyRefundOrderShippingAmount(payload));
    trackDecisionTreeOrderShippingRefunded();
  };

  return (
    <DTCopyTextSendMacroView
      buttonText={'REFUND SHIPPING'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={false}
      popupConfirmationText={'You are about to refund order shipping amount'}
    />
  );
};

export default withConfirmation(DTRefundShippingThenSendMacroNode);
